
import {call, put, takeEvery} from 'redux-saga/effects';
import {
  blockCardApi,
  bulkAddDriverUploadApi,
  bulkTransferSampleApi,
  bulkTransferUploadApi,
  changeDriverLimitApi,
  customerMiniKyc,
  deleteExpenseApi,
  editExpenseApi,
  getExpenseImageAPI,
  getWalletTransactionHistoryApi,
  kycDoneApi,
  modifyLimitApi,
  qrcodeApi,
  registorNewCustomer,
  registorNewCustomerVerifyOtp,
  replaceCardApi,
  verfiyOtpForLimitApi,
  bulkWithdrawlUploadApi,
  bulkAddDriveCompleteUploadApi,
  getTransactionDetailsApi,
  getTransactionSlipPdfApi,
  getCardTransactionDetailsApi,
  getCardTransactionSlipPdfApi,
  getFastagTransactionDetailsApi,
  getFastagTransactionSlipPdfApi,
  getFastagWalletTransactionDetailsApi,
  getFastagWalletTransactionSlipPdfApi,
  saveSlipActionApi,
  getCardWalletBalanceApi,
  getCardWalletHistoryApi,
  createCardWalletApi,
  getCardWalletStatementApi,
  downloadCardWalletTxnSlipPdfApi,
  getCardWalletTxnSlipApi,
} from '../../Utils/Apis';
import {processErrorAndRespond} from '../../Utils/functions';
import { toastStatus } from '../Actions/appActions';
import {
  blockCardSuccess,
  bulkAddDriverUploadSuccess,
  bulkTransferSampleSuccess,
  bulkWithdrawlUploadSuccess,
  changeDriverLimitSuccess,
  customerMiniKycSuccess,
  deleteExpenseActionSuccess,
  editExpenseActionSuccess,
  getExpenseImageSuccessAction,
  getFuelWalletbalSuccess,
  getWalletTransactionHistorySuccess,
  kycDoneActionSuccess,
  modifyLimitSuccess,
  qrcodeActionSuccess,
  registorNewCustomerSuccess,
  registorNewCustomerVerifyOtpSuccess,
  replaceCardSuccess,
  verifyOtpForLimitSuccess,
  bulkAddDriverCompleteUploadSuccess,
  getTransactionDetailsSuccess,
  getTransactionSlipPdfSuccess,
  getCardTransactionDetailsSuccess,
  getCardTransactionSlipPdfSuccess,
  getFastagTransactionDetailsSuccess,
  getFastagTransactionSlipPdfSuccess,
  getFastagWalletTransactionDetailsSuccess,
  getFastagWalletTransactionSlipPdfSuccess,
  saveSlipActionSuccess,
  getCardWalletBalanceSuccess,
  getCardWalletHistorySuccess,
  createCardWalletSuccess,
  getCardWalletStatementSuccess,
  clearCardWalletHistory,
  downloadCardWalletTxnSlipPdfSuccess,
  getCardWalletTxnSlipSuccess,
} from '../Actions/walletAction';
import {
  WALLET_TRANSACTION_HISTORY,
  KYC_DONE,
  GET_EXPENSE_IMAGE,
  DELETE_EXPENSE,
  EDIT_EXPENSE,
  QR_CODE,
  BULK_TRANSFER_SAMPLE,
  BULK_TRANSFER_UPLOAD,
  BULK_ADD_DRIVER_UPLOAD,
  CHANGE_DRIVER_LIMIT,
  MODIFY_LIMIT,
  VERIFY_OTP_FOR_LIMIT,
  REGISTOR_NEW_CUSTOMER,
  REGISTOR_NEW_CUSTOMER_VERIFY_OTP,
  CUSTOMER_MIN_KYC,
  REPLACE_CARD,
  BLOCK_CARD,
  BULK_WITHDRAWL_UPLOAD,
  BULK_ADD_DRIVER_COMPLETE_UPLOAD,
  GET_TRANSACTION_DETAILS,
  GET_TRANSACTION_SLIP_PDF,
  GET_CARD_TRANSACTION_DETAILS,
  GET_FASTAG_TRANSACTION_DETAILS,
  GET_FASTAG_WALLET_TRANSACTION_DETAILS,
  GET_CARD_TRANSACTION_SLIP_PDF,
  GET_FASTAG_TRANSACTION_SLIP_PDF,
  GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF,
  SAVE_SLIP,
  CREATE_CARD_WALLET,
  GET_CARD_WALLET_HISTORY,
  GET_CARD_WALLET_BALANCE,
  GENERATE_CARD_WALLET_STATEMENT,
  DOWNLOAD_CARD_WALLET_TXNSLIP_PDF,
  GET_CARD_WALLET_TXNSLIP,
} from '../storeTypes';


function* getWalletTransactionHistorySaga(action) {
  try {
    const response = yield call(getWalletTransactionHistoryApi, action.payload);
    console.log("getWalletTransactionHistorySaga >>> ", response?.data);
    if (response.data.type == 'success') {
      console.log("success",response?.data?.data );
      yield put(getWalletTransactionHistorySuccess(response?.data?.data));
    }
  } catch (error) {
    console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* kycDoneSaga(action) {
  try {
    const response = yield call(kycDoneApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(kycDoneActionSuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}


function* getExpenseImageSaga(action) {
  try {
    const response = yield call(getExpenseImageAPI, action.typeExp, action.id);
    console.log("data", response);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(getExpenseImageSuccessAction(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    // yield put(
    //   toastStatus({
    //     toastStatus: true,
    //     message: `Error : ${error?.response?.data?.message}`,
    //     status: false,
    //   })
    // );
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* deleteExpenseSaga(action) {
  try {
    const response = yield call(deleteExpenseApi, action.payload);
    console.log("rrrrrrrrrrrr ", response);
    if (response.data.type == 'success') {
      console.log("success",response?.data?.data );
      yield put(deleteExpenseActionSuccess(response?.data?.data));
      yield put(
        toastStatus({
          toastStatus: true,
          message:"Expense data deleted successfully",
          status: true,
        })
      );
    }
  } catch (error) {
    console.log('Error.Response:- ', error.response);
    yield put(
      toastStatus({
        toastStatus: true,
        message: `Error : ${error?.response?.data}`,
        status: false,
      })
    );
    //Alert.alert('Error', error.response.data.message);
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}


function* editExpenseSaga(action) {
  try {
    const response = yield call(editExpenseApi, action.id, action.payload);
    //console.log("rrrrrrrrrrrr ", response);
    if (response.data.type == 'success') {
      //console.log("success",response?.data?.data );
      yield put(editExpenseActionSuccess(response?.data?.data));
      yield put(
        toastStatus({
          toastStatus: true,
          message:"Expense data was edited successfully",
          status: true,
        })
      );
    }
  } catch (error) {
    console.log('Error.Response:- ', error.response);
    yield put(
      toastStatus({
        toastStatus: true,
        message: `Error : ${error?.response?.data}`,
        status: false,
      })
    );
    //Alert.alert('Error', error.response.data.message);
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}


function* qrcodeSaga(action) {
  try {
    const response = yield call(qrcodeApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      // action.callback(response);
      yield put(qrcodeActionSuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* bulkTransferSampleSaga(action) {
  try {
    const response = yield call(bulkTransferSampleApi, action.payload);
    // if (response.type == "success") {
      action.callback(response);
      yield put(bulkTransferSampleSuccess(response));
    // }
  } catch (error) {
    console.log('Error.Response:- ', error);
    //Alert.alert('Error', error.response.data.message);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* bulkTransferUploadSaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(bulkTransferUploadApi, action.payload);
    // if (response.type == "success") {
      action.callback(response);
      yield put(bulkTransferSampleSuccess(response));
    // }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    action.callback(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* bulkAddDriverUploadSaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(bulkAddDriverUploadApi, action.payload);
    // if (response.type == "success") {
      action.callback(response);
      yield put(bulkAddDriverUploadSuccess(response));
    // }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    action.callback(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* changeDriverLimitsaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(changeDriverLimitApi, action.payload);
    if (response.status == 200) {
      action.callback(response);
      yield put(changeDriverLimitSuccess(response));
      yield put(
        toastStatus({
          toastStatus: true,
          message: "Limit has been updated successfully",
          status: true,
        })
      );
    }
  } catch (error) {
    console.log('Error.Response:- ', error);
    //Alert.alert('Error', error.response.data.message);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    action.callback(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* modifyLimitSaga(action) {
  try {
    const response = yield call(modifyLimitApi, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response?.data);
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* verfiyOtpForLimitSaga(action) {
  try {
    const response = yield call(verfiyOtpForLimitApi, action.payload);
    action.callBack(response);
    if (response?.status == 200) {
      yield put(verifyOtpForLimitSuccess(response?.data?.data));
      yield put(
        toastStatus({
          toastStatus: true,
          message: "Limit has been updated successfully",
          status: true,
        })
      );
    }
  } catch (error) {
    console.log('verfiyOtpForLimit errpr:- ', error?.response);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* registorNewCustomerSaga(action) {
  try {
    const response = yield call(registorNewCustomer, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response?.data);
      yield put(registorNewCustomerSuccess(response));
      toastStatus({
        toastStatus: true,
        message: response?.data?.data?.message,
        status: true,
      })
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: (error?.response?.data?.message == "Failed to Add Customer" ? (error?.response?.data?.data?.message+ " | YesBank") : error?.response?.data?.message) || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* registorNewCustomerVerifyOtpSaga(action) {
  try {
    const response = yield call(registorNewCustomerVerifyOtp, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response);
      yield put(registorNewCustomerVerifyOtpSuccess(response));
      toastStatus({
        toastStatus: true,
        message: response?.data?.data?.message,
        status: true,
      })
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack(error?.response);
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* customerMiniKycSaga(action) {
  try {
    const response = yield call(customerMiniKyc, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response);
      yield put(customerMiniKycSuccess(response));
      yield put (toastStatus({
        toastStatus: true,
        message: response?.data?.data?.message,
        status: true,
      }))
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* replaceCardSaga(action) {
  try {
    const response = yield call(replaceCardApi, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response);
      yield put(replaceCardSuccess(response));
      yield put (toastStatus({
        toastStatus: true,
        message: response?.data?.message,
        status: true,
      }))
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* blockCardSaga(action) {
  try {
    const response = yield call(blockCardApi, action.payload);
    if (response?.data?.type == 'success') {
      action.callBack(response);
      yield put(blockCardSuccess(response));
      yield put (toastStatus({
        toastStatus: true,
        message: response?.data?.message,
        status: true,
      }))
  }
  } catch (error) {
    console.log('modifyLimitSaga errpr:- ', error);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* bulkWithdrawlUploadSaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(bulkWithdrawlUploadApi, action.payload);
    // if (response.type == "success") {
      action.callback(response);
      yield put(bulkWithdrawlUploadSuccess(response));
    // }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    action.callback(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* bulkAddDriveCompleteUploadSaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(bulkAddDriveCompleteUploadApi, action.payload);
    // if (response.type == "success") {
      action.callback(response);
      yield put(bulkAddDriverCompleteUploadSuccess(response));
    // }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    action.callback(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* getTransactionDetailsSaga(action) {
  try {
    const response = yield call(getTransactionDetailsApi, action?.payload);
    if (response?.data?.type == 'success') {
      console.log(
        'THIS ONE KKDMLMDLKMVLFMVMFNMVFNVNFLVNFLNVLFNVLNFLVNLFNVLFNVLKFNVLNFLVNLFNVLFNLVNFL',
      );
      yield put(getTransactionDetailsSuccess(response?.data?.data));
      // yield put (toastStatus({
      //   toastStatus: true,
      //   message: response?.data?.message,
      //   status: true,
      // }))
    }
  } catch (error) {
    console.log(
      'getTransactionDetailsSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getCardTransactionDetailsSaga(action) {
  try {
    const response = yield call(getCardTransactionDetailsApi, action?.payload);
    if (response?.data?.type == 'success') {
      yield put(getCardTransactionDetailsSuccess(response?.data?.data));
      // yield put (toastStatus({
      //   toastStatus: true,
      //   message: response?.data?.message,
      //   status: true,
      // }))
      action.callBack(response.data);
    }
  } catch (error) {
    console.log(
      'getCardTransactionDetailsSaga error .Response:- ',
      error?.response?.data,
    );
    action.callBack(error.data);
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getFastagTransactionDetailsSaga(action) {
  try {
    const response = yield call(
      getFastagTransactionDetailsApi,
      action?.payload,
    );
    console.log('response', response?.data);
    if (response?.data?.type == 'success') {
      yield put(getFastagTransactionDetailsSuccess(response?.data?.data));
      // yield put (toastStatus({
      //   toastStatus: true,
      //   message: response?.data?.message,
      //   status: true,
      // }))
    }
  } catch (error) {
    console.log(
      'getFastagTransactionDetailsSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getFastagWalletTransactionDetailsSaga(action) {
  try {
    const response = yield call(
      getFastagWalletTransactionDetailsApi,
      action?.payload,
    );
    console.log('res', response?.data);
    if (response?.data?.type == 'success') {
      yield put(getFastagWalletTransactionDetailsSuccess(response?.data?.data));
      // yield put (toastStatus({
      //   toastStatus: true,
      //   message: response?.data?.message,
      //   status: true,
      // }))
    }
  } catch (error) {
    console.log(
      'getFastagWalletTransactionDetailsSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getTransactionSlipPdfSaga(action) {
  try {
    console.log('getTransactionSlipPdfSaga ');
    const response = yield call(getTransactionSlipPdfApi, action?.payload);
    if (response?.data?.type == 'success') {
      console.log('--------- ', response?.data);
      action?.callBack(response?.data?.data?.url);
      yield put(getTransactionSlipPdfSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log(
      'getTransactionSlipPdfSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getCardTransactionSlipPdfSaga(action) {
  try {
    console.log('getTransactionSlipPdfSaga ');
    const response = yield call(getCardTransactionSlipPdfApi, action?.payload);
    if (response?.data?.type == 'success') {
      console.log('--------- ', response?.data);
      action?.callBack(response?.data?.data?.url);
      yield put(getCardTransactionSlipPdfSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log(
      'getCardTransactionSlipPdfSaga error .Response:- ',
      error?.response?.data,
    );
    yield put(
        toastStatus({
          toastStatus: true,
          message: error?.response?.data?.message || "ERROR",
          status: false,
        })
      );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getFastagTransactionSlipPdfSaga(action) {
  try {
    console.log('getTransactionSlipPdfSaga ');
    const response = yield call(
      getFastagTransactionSlipPdfApi,
      action?.payload,
    );
    if (response?.data?.type == 'success') {
      console.log('--------- ', response?.data);
      action?.callBack(response?.data?.data?.url);
      yield put(getFastagTransactionSlipPdfSuccess(response?.data?.data));
    }
  } catch (error) {
      yield put(
          toastStatus({
            toastStatus: true,
            message: error?.response?.data?.message || "ERROR",
            status: false,
          })
        );
      if (error?.response?.status == 400) {
        action.callBack({
          message: error?.response?.data?.message,
        });
      } else {
        action.callBack(error?.response?.data?.error);
      }
      console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* getFastagWalletTransactionSlipPdfSaga(action) {
  try {
    console.log('getTransactionSlipPdfSaga ');
    const response = yield call(
      getFastagWalletTransactionSlipPdfApi,
      action?.payload,
    );
    if (response?.data?.type == 'success') {
      console.log('--------- ', response?.data);
      action?.callBack(response?.data?.data?.url);
      yield put(getFastagWalletTransactionSlipPdfSuccess(response?.data?.data));
    }
  } catch (error) {
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* saveSlipActionSaga(action) {
  try {
    const response = yield call(saveSlipActionApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(saveSlipActionSuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getCardWalletBalanceSaga(action) {
  try {
    const response = yield call(getCardWalletBalanceApi, action.payload);
    console.log("getCardWalletBalanceSaga", response?.data?.data);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(getCardWalletBalanceSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log('Error.getCardWalletBalanceSaga:- ', error?.response?.data?.message == "Owner not found");
    if(error?.response?.data?.message == "Owner not found"){
      yield put(getCardWalletBalanceSuccess({status: 0}));
    }
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getCardWalletHistorySaga(action) {
  try {
    const response = yield call(getCardWalletHistoryApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      yield put(clearCardWalletHistory())
      action.callback(response);
      yield put(getCardWalletHistorySuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* createCardWalletSaga(action) {
  try {
    const response = yield call(createCardWalletApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(
        toastStatus({
          toastStatus: true,
          message: response?.data?.message || "Onboarded successfully",
          status: true,
        })
      );
      yield put(createCardWalletSuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}


function* getCardWalletStatementSaga(action) {
  try {
    const response = yield call(getCardWalletStatementApi, action.payload);
    console.log("data", response);
    if (response.data.type == "success") {
      action.callback(response);
      // yield put(
      //   toastStatus({
      //     toastStatus: true,
      //     message: response?.data?.message || "Onboarded successfully",
      //     status: true,
      //   })
      // );
      yield put(getCardWalletStatementSuccess(response?.data?.data));
    }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //alert(`Error : ${error.response.data.message}`);
    yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getCardWalletTxnSlipSaga(action) {
  try {
    const response = yield call(
      getCardWalletTxnSlipApi,
      action?.payload,
    );
    console.log('res', response?.data);
    if (response?.data?.type == 'success') {
      yield put(getCardWalletTxnSlipSuccess(response?.data?.data));
      // yield put (toastStatus({
      //   toastStatus: true,
      //   message: response?.data?.message,
      //   status: true,
      // }))
    }
  } catch (error) {
    console.log(
      'getCardWalletTxnSlipSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}
function* downloadCardWalletTxnSlipPdfSaga(action) {
  try {
    console.log('downloadCardWalletTxnSlipPdfSaga ');
    const response = yield call(downloadCardWalletTxnSlipPdfApi, action?.payload);
    if (response?.data?.type == 'success') {
      console.log('--------- ', response?.data);
      action?.callback(response?.data?.data?.url);
      yield put(downloadCardWalletTxnSlipPdfSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log(
      'downloadCardWalletTxnSlipPdfSaga error .Response:- ',
      error?.response?.data,
    );
   yield put(
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "ERROR",
        status: false,
      })
    );
    if (error?.response?.status == 400) {
      action.callBack({
        message: error?.response?.data?.message,
      });
    } else {
      action.callBack(error?.response?.data?.error);
    }
    console.log('API Error:- ', processErrorAndRespond(error));
  }
}

export function* watchWalletSagas() {
    yield takeEvery(WALLET_TRANSACTION_HISTORY, getWalletTransactionHistorySaga);
    yield takeEvery(KYC_DONE, kycDoneSaga);
    yield takeEvery(GET_EXPENSE_IMAGE,getExpenseImageSaga);
    yield takeEvery(DELETE_EXPENSE,deleteExpenseSaga);
    yield takeEvery(EDIT_EXPENSE,editExpenseSaga);
    yield takeEvery(QR_CODE,qrcodeSaga);
    yield takeEvery(BULK_TRANSFER_SAMPLE,bulkTransferSampleSaga);
    yield takeEvery(BULK_TRANSFER_UPLOAD,bulkTransferUploadSaga);
    yield takeEvery(BULK_ADD_DRIVER_UPLOAD,bulkAddDriverUploadSaga);
    yield takeEvery(CHANGE_DRIVER_LIMIT,changeDriverLimitsaga);
    yield takeEvery(MODIFY_LIMIT, modifyLimitSaga);
    yield takeEvery(VERIFY_OTP_FOR_LIMIT, verfiyOtpForLimitSaga);
    yield takeEvery(REGISTOR_NEW_CUSTOMER,registorNewCustomerSaga);
    yield takeEvery(REGISTOR_NEW_CUSTOMER_VERIFY_OTP,registorNewCustomerVerifyOtpSaga);
    yield takeEvery(CUSTOMER_MIN_KYC,customerMiniKycSaga);
    yield takeEvery(REPLACE_CARD,replaceCardSaga);
    yield takeEvery(BLOCK_CARD,blockCardSaga);
    yield takeEvery(BULK_WITHDRAWL_UPLOAD,bulkWithdrawlUploadSaga);
    yield takeEvery(BULK_ADD_DRIVER_COMPLETE_UPLOAD,bulkAddDriveCompleteUploadSaga);
    

    yield takeEvery(GET_TRANSACTION_DETAILS, getTransactionDetailsSaga);
    yield takeEvery(GET_TRANSACTION_SLIP_PDF, getTransactionSlipPdfSaga);
    yield takeEvery(
      GET_CARD_TRANSACTION_DETAILS,
      getCardTransactionDetailsSaga,
    );
    yield takeEvery(
      GET_FASTAG_TRANSACTION_DETAILS,
      getFastagTransactionDetailsSaga,
    );
    yield takeEvery(
      GET_FASTAG_WALLET_TRANSACTION_DETAILS,
      getFastagWalletTransactionDetailsSaga,
    );
    yield takeEvery(
      GET_CARD_TRANSACTION_SLIP_PDF,
      getCardTransactionSlipPdfSaga,
    );
    yield takeEvery(
      GET_FASTAG_TRANSACTION_SLIP_PDF,
      getFastagTransactionSlipPdfSaga,
    );
    yield takeEvery(
      GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF,
      getFastagWalletTransactionSlipPdfSaga,
    );
    yield takeEvery(SAVE_SLIP, saveSlipActionSaga);

    yield takeEvery(GET_CARD_WALLET_BALANCE,getCardWalletBalanceSaga);
    yield takeEvery(GET_CARD_WALLET_HISTORY,getCardWalletHistorySaga);
    yield takeEvery(CREATE_CARD_WALLET,createCardWalletSaga);
    yield takeEvery(GENERATE_CARD_WALLET_STATEMENT,getCardWalletStatementSaga);
    yield takeEvery(GET_CARD_WALLET_TXNSLIP,getCardWalletTxnSlipSaga);
    yield takeEvery(DOWNLOAD_CARD_WALLET_TXNSLIP_PDF,downloadCardWalletTxnSlipPdfSaga);

    
}
